import { apiGet, apiPost, apiPatch } from 'chipta-libs/api/utils.js';

class AccountAPI {

  requestSignUp(email, status=null) {

    const data = { email };

    if (status) {
      data.status = status;
    }

    return new Promise((success, reject) => {
      apiPost('account/sign-up/', data).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  /**
   * Resend the sign-up email, so the user can validate it's email address, so
   * it can log in and use it's account.
   */
  resendSignupEmail(email, password) {
    return new Promise((success, reject) => {
      apiPost('account/resend-signup-email/', {
        email, password
      }).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  /**
   * Make a sign-up request complete.
   *
   * After you follow the link in the sign-up email, you fill in a form with
   * some extra data to complete your account. This function sends the form
   * data to the API.
   *
   * The given `data` argument should be a dict with at least these keys:
   *
   *     token, password, first_name, last_name
   */
  completeSignUp(data) {
    return new Promise((success, reject) => {
      apiPost('account/sign-up/', data).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  requestPasswordReset(email) {
    return new Promise((success, reject) => {
      apiPost('account/password-reset/', {'email': email}).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  getPersonalDetails() {
    return new Promise((success, reject) => {
      apiGet('account/personal-details/').then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  updatePersonalDetails(data) {
    return new Promise((success, reject) => {
      apiPatch('account/personal-details/', data).then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  requestEmailUpdate() {
    return new Promise((success, reject) => {
      apiPost('account/update-email/').then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

  getOmpOauthSetups() {
    return new Promise((success, reject) => {
      apiGet('account/online-meeting-providers/').then(response => {
        success(response.data);
      }).catch(response => {
        reject(response.data);
      });
    });
  }

}

export const accountAPI = new AccountAPI();
